import { GridColumnMenuFilter, GridColumnMenuProps } from '@progress/kendo-react-grid';
import { ComponentType } from 'react';
import ContractedIcon from 'src/assets/icons/ContractedIcon';
import FavoritesIcon from 'src/assets/icons/FavoritesIcon';
import FormularyIcon from 'src/assets/icons/FormularyIcon';
import OfflineIcon from 'src/assets/icons/OfflineIcon';
import PictureAvailableIcon from 'src/assets/icons/PictureAvailableIcon';
import SpecialOrderIcon from 'src/assets/icons/SpecialOrderIcon';
import AttributeFilterUI, {
  AttributeFilterOption,
  AttributeType,
} from 'src/components/AttributeFilterUI';

export type { AttributeType };

// Define the order of attributes - used for consistent display ordering
export const ATTRIBUTE_ORDER: AttributeType[] = [
  'isContracted', // Temporarily hidden — re-enable with catalogAttributeOptions Contracted Item entry
  'isOfflineSupplierItem',
  'productInFavoriteFolder',
  'isSpecialOrder',
  'isImageAvailable',
  'isFormulary',
  'hasOldProductId',
];

export const sortAttributesByOrder = (attributes: string[]): string[] =>
  [...attributes].sort((a, b) => {
    const indexA = ATTRIBUTE_ORDER.indexOf(a as AttributeType);
    const indexB = ATTRIBUTE_ORDER.indexOf(b as AttributeType);
    // If attribute not found in order, place it at the end
    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });

const catalogAttributeOptions: AttributeFilterOption[] = [
  {
    type: 'isContracted',
    label: 'Contracted Item',
    icon: <ContractedIcon />,
  },
  {
    type: 'isOfflineSupplierItem',
    label: 'Offline Supplier Item',
    icon: <OfflineIcon />,
  },
  {
    type: 'productInFavoriteFolder',
    label: 'In Shopping List',
    icon: <FavoritesIcon />,
  },
  {
    type: 'isSpecialOrder',
    label: (
      <span style={{ display: 'block', lineHeight: '1.3', whiteSpace: 'nowrap' }}>
        Special Order - Item may incur
        <br />
        additional shipping charges
      </span>
    ),
    icon: <SpecialOrderIcon />,
  },
  {
    type: 'isImageAvailable',
    label: 'Picture Available',
    icon: <PictureAvailableIcon />,
  },
  {
    type: 'isFormulary',
    label: 'Company Specified',
    icon: <FormularyIcon />,
  },
];

const AttributesFilter: ComponentType<GridColumnMenuProps> = (columnMenuProps) => (
  <GridColumnMenuFilter
    {...columnMenuProps}
    expanded={true}
    hideSecondFilter
    filterUI={(filterUIProps) => (
      <AttributeFilterUI {...filterUIProps} attributeOptions={catalogAttributeOptions} />
    )}
  />
);

export default AttributesFilter;
